import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { OrganizationProfile, TemplateIntakeForm } from "schemas/dashboard";

import { BackgroundDetails } from "../schema";

interface Props {
  openIntakeDialog: boolean;
  setOpenIntakeDialog: Dispatch<SetStateAction<boolean>>;
  setIntakeForm: Dispatch<SetStateAction<TemplateIntakeForm | null>>;
  intakeForm: TemplateIntakeForm | null;
  backgroundDetails: BackgroundDetails[];
  orgProfile: OrganizationProfile | null;
}

const UserIntakeFormDialog = ({
  openIntakeDialog,
  setOpenIntakeDialog,
  setIntakeForm,
  backgroundDetails,
  orgProfile,
  intakeForm,
}: Props) => {
  return (
    <Dialog
      open={openIntakeDialog}
      onClose={() => {
        setOpenIntakeDialog(false);
        setIntakeForm(null);
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center" }}>
        User Intake For Pending Template{" "}
      </DialogTitle>

      <DialogContent sx={{ mt: -3 }}>
        <Divider sx={{ my: 3, mx: -3 }} />
        <Typography variant="h6">General Information </Typography>

        <ul>
          {orgProfile?.location && <li>Location: {orgProfile?.location} </li>}
          {orgProfile?.city && <li>City: {orgProfile?.city} </li>}
          {orgProfile?.portfolioUrl && (
            <li>
              Portfolio:{" "}
              <Link href={orgProfile?.portfolioUrl} target="_blank">
                {orgProfile?.portfolioUrl}
              </Link>{" "}
            </li>
          )}
          {orgProfile?.instagramUrl && (
            <li>
              Instagram:{" "}
              <Link href={orgProfile?.instagramUrl} target="_blank">
                {orgProfile?.instagramUrl}
              </Link>{" "}
            </li>
          )}
          {orgProfile?.tiktokUrl && (
            <li>
              TikTok:{" "}
              <Link href={orgProfile?.tiktokUrl} target="_blank">
                {orgProfile?.tiktokUrl}
              </Link>{" "}
            </li>
          )}
          {orgProfile?.youtubeUrl && (
            <li>
              YouTube:{" "}
              <Link href={orgProfile?.youtubeUrl} target="_blank">
                {orgProfile?.youtubeUrl}
              </Link>{" "}
            </li>
          )}
          {orgProfile?.twitchUrl && (
            <li>
              Twitch:{" "}
              <Link href={orgProfile?.twitchUrl} target="_blank">
                {orgProfile?.twitchUrl}
              </Link>{" "}
            </li>
          )}
          {orgProfile?.numOfFollowers && (
            <li>Number of Followers: {orgProfile?.numOfFollowers}</li>
          )}
          {orgProfile?.introduction && (
            <li>Introduction: {orgProfile?.introduction}</li>
          )}
        </ul>

        <Divider sx={{ my: 3, mx: -3 }} />
        <Typography variant="h6">Intake Form Answers </Typography>

        <ul>
          <li>
            <strong>Notes</strong>: {intakeForm?.notes || "N/A"}
          </li>
          <li>
            <strong>Past Brands</strong>: {intakeForm?.pastBrands || ""}
          </li>
          <li>
            <strong>Share 2-3 unique facts about you</strong>:{" "}
            {intakeForm?.partnershipReason || "N/A"}
          </li>
          {intakeForm?.nicheName ? (
            <li>
              <strong>Write for this niche </strong>: {intakeForm?.nicheName}
            </li>
          ) : (
            <li>
              <strong>Template Type</strong>: Generic
            </li>
          )}
        </ul>

        <Divider sx={{ my: 3, mx: -3 }} />
        <Typography variant="h6">Background Details </Typography>
        <ul>
          {backgroundDetails.map((detail, index) => (
            <li key={index}>
              <strong>{detail.question}</strong> <br /> {detail.answer || "N/A"}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpenIntakeDialog(false);
            setIntakeForm(null);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserIntakeFormDialog;
